const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
// @ Commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
// @ components
const {
    CardChargeStep1
} = require('components/cards/cardChargeSteps/cardChargeStep1/cardChargeStep1');
const CardChargeStep2 = require('components/cards/cardChargeSteps/cardChargeStep2/cardChargeStep2');
// @ Constants
const {
    MONEY_REQUEST_VIEW,
    DATE_FORMAT_API,
    PERIODICITY_BIANNUAL,
    PERIODICITY_HALF_YEARLY,
    SAVINGS_REQUEST_VIEW
} = require('constants/index');

// @utilities
const { toFirstUppercase } = require('utilities/stringHelper');
const { getEndDateForCardCharge } = require('utilities/cardsHelper');
class CardCharge extends React.Component {
    constructor(props) {
        super(props);
        this.onCancel = this.onCancel.bind(this);
    }

    onCancel() {
        const {
            history,
            immCard,
            immCardCharge,
            view
        } = this.props;
        const immCardChargeStep1 = immCardCharge.getIn(['steps', 0]);
        const isEditFlow = immCardChargeStep1.get('isEdit');
        const cardId = immCard.get('cardId');
        if(view === MONEY_REQUEST_VIEW || view === SAVINGS_REQUEST_VIEW) {
            history.push(`/myprofile/global`);
        } else if(isEditFlow) {
            history.push(`/myprofile/cards/${cardId}/periodic-loads`);
        } else {
            history.push(`/myprofile/cards/${cardId}/movements`);
        }
    }

    render() {
        const {
            immCardCharge,
            immCard,
            isInactiveAccountsEnabled,
            validateStep,
            oyAccounts,
            setAllAccountsToInactive,
            setVisibleStep,
            setWillCancel,
            postChange,
            isPeriodicTransfer,
            immAccounts,
            view,
            moneyRequestDetails
        } = this.props;
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: postChange,
            cancel: this.onCancel
        };
        const immSteps = immCardCharge.get('steps');
        const immCardChargeStep1 = immCardCharge.getIn(['steps', 0]);
        const editInfo = immCardChargeStep1.get('editInfo');
        let scheduleType = toFirstUppercase(immCardChargeStep1.get('periodicityRange'));
        if(scheduleType === toFirstUppercase(PERIODICITY_BIANNUAL)){
            scheduleType = PERIODICITY_HALF_YEARLY;
        }
        let nextButtonDisabled = false;

        if(immCardChargeStep1.get('isEdit')) {
            nextButtonDisabled = (editInfo.get('transferAmount') === immCardChargeStep1.get('amount'))
                            && (editInfo.get('startDate') === immCardChargeStep1.get('date').format(DATE_FORMAT_API))
                            && (editInfo.get('endDate') === getEndDateForCardCharge(immCardChargeStep1))
                            && (editInfo.get('scheduleType') === scheduleType)
                            && (editInfo.get('comment') === immCardChargeStep1.get('periodicityConcept'));
        }

        return (
            <Wizard
                wizardClass="card-charge__wizard"
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={immCardCharge.get('visibleStep')}
                showPreLeaveModal={true}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    isLoading={immCardCharge.get('isFetching')}
                    nextButtonDisabled={nextButtonDisabled}
                >
                    <CardChargeStep1
                        immAccounts={immAccounts}
                        immCard={immCard}
                        immCardCharge={immCardCharge}
                        isInactiveAccountsEnabled={isInactiveAccountsEnabled}
                        accountId={immSteps.getIn([0, 'accountId'])}
                        operationType={immSteps.getIn([0, 'operationType'])}
                        isLoading={immCardCharge.get('isFetching')}
                        isPeriodicTransfer={isPeriodicTransfer}
                        view={view}
                        moneyRequestDetails={moneyRequestDetails}
                        oyAccounts={oyAccounts}
                        setAllAccountsToInactive={setAllAccountsToInactive}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    immFinalButton="cardCharge-change"
                    isLoading={immCardCharge.get('isFetching')}
                >
                    <CardChargeStep2
                        immAccounts={immAccounts}
                        immCard={immCard}
                        immCardCharge={immCardCharge}
                        view={view}
                    />
                </WizardStep>
            </Wizard>
        );
    }
}

CardCharge.defaultProps = {
    isPeriodicTransfer: false
}

CardCharge.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired,
    immCardCharge: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool,
    isPeriodicTransfer: PropTypes.bool.isRequired,
    postChange: PropTypes.func.isRequired,
    oyAccountsList: PropTypes.object,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    moneyRequestDetails: PropTypes.object,
    oyAccounts: PropTypes.object,
    view: PropTypes.string
};

module.exports = withRouter(CardCharge);
